export const copyTextToClipBoard = async (text: string) => {
  const blobHtml = new Blob([text], {type: 'text/html'});
  const blobText = new Blob([text.replace(/<\/?[^>]+(>|$)/g, '')], {type: 'text/plain'});

  const clipboardItem = new ClipboardItem({
    'text/html': blobHtml,
    'text/plain': blobText,
  });

  try {
    await navigator.clipboard.write([clipboardItem]);
    return true;
  } catch (error) {
    return false;
  }
};
